module.exports = __webpack_public_path__ + "8ef63846b9fde78520148f9470db498f.png";